import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { BsDatepickerConfig } from "ngx-bootstrap";
import { JoineeService } from "src/app/services/joinee.service";
import { MotorService } from "src/app/services/motor.service";
import { SpinnerService } from "src/app/services/spinner.service";
import { DatePipe } from "@angular/common";
import { Constants } from "src/app/shared/constants";
import { AlertService } from "src/app/services/alert.service";

@Component({
  selector: "app-new-joinee-application",
  templateUrl: "./new-joinee-application.component.html",
  styleUrls: ["./new-joinee-application.component.css"],
})
export class NewJoineeApplicationComponent implements OnInit {
  serverTaskForm: FormGroup;
  errors: any = [];
  result: any = [];
  submitted = false;
  dataLength: any;
  keys: any;
  adultMinDOB: Date;
  adultMaxDOB: Date;
  pdfOnly: boolean = false;

  bsDatepickerConfig: Partial<BsDatepickerConfig> = {};

  ctcMaster: any = [
    "0 - 3 Lakh",
    "3 - 5 Lakh",
    "5 - 7 Lakh",
    "7 - 9 Lakh",
    "9 - 11 Lakh",
    "11 Lakh & Above",
  ];
  salutationMaster: any = ["Mr.","Mrs.", "Ms."]
  highestEductationMaster: any = ["Post-Graduation", "Graduation", "Diploma"];
  noticePeriodMaster: any = ["NIL", "15 Days", "1 Month", "2 Months", "3 Months"];
  ageMaster: any = [
    18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36,
    37, 38, 39, 40, 41, 42, 43, 44, 45,
  ];
  insuranceQualificationMaster: any = ["NIL", "Fellowship", "Associate", "Licentiate"];
  functionMaster: any = [
    "Marketing",
    "Underwriting",
    "Claims",
    "Finance & Accounts",
    "IT",
    "Legal",
    "Actuary",
    "Other",
  ];
  experienceMaster: any = [
    " 0 - 1 Year",
    "1 - 4 Years",
    "4 - 9 Years",
    "9 - 12 Years",
    "12 Years & above",
  ];

  locationMaster: any = [
    [
        "Agra",
        "Uttar Pradesh"
    ],
    [
        "Ahmedabad",
        "Gujarat"
    ],
    [
        "Ahmednagar",
        "Maharashtra"
    ],
    [
        "Aizawl",
        "Mizoram"
    ],
    [
        "Ajmer",
        "Rajasthan"
    ],
    [
        "Akola",
        "Maharashtra"
    ],
    [
        "Alipurduar",
        "West Bengal"
    ],
    [
        "Allahabad",
        "Uttar Pradesh"
    ],
    [
        "Alwar",
        "Rajasthan"
    ],
    [
        "Amalapuram",
        "Andhra Pradesh"
    ],
    [
        "Ambala",
        "Haryana"
    ],
    [
        "Ambikapur",
        "Chhattisgarh"
    ],
    [
        "Amethi",
        "Uttar Pradesh"
    ],
    [
        "Amravati",
        "Maharashtra"
    ],
    [
        "Amritsar",
        "Punjab"
    ],
    [
        "Anand",
        "Gujarat"
    ],
    [
        "Anandpur",
        "Odisha"
    ],
    [
        "Anantapur",
        "Andhra Pradesh"
    ],
    [
        "Anantnag",
        "Jammu & Kashmir"
    ],
    [
        "Angul",
        "Odisha"
    ],
    [
        "Ankleshwar",
        "Gujarat"
    ],
    [
        "Anna Nagar",
        "Tamil Nadu"
    ],
    [
        "Ashoknagar",
        "Madhya Pradesh"
    ],
    [
        "Athagarh",
        "Odisha"
    ],
    [
        "Aurangabad",
        "Maharashtra"
    ],
    [
        "Avinashi",
        "Tamil Nadu"
    ],
    [
        "Bagalkote",
        "Karnataka"
    ],
    [
        "Baikunthpur",
        "Chhattisgarh"
    ],
    [
        "Balaghat",
        "Madhya Pradesh"
    ],
    [
        "Balasore",
        "Odisha"
    ],
    [
        "Bangalore",
        "Karnataka"
    ],
    [
        "Bankura",
        "West Bengal"
    ],
    [
        "Banswara",
        "Rajasthan"
    ],
    [
        "Banur",
        "Punjab"
    ],
    [
        "Bapunagar",
        "Gujarat"
    ],
    [
        "Bardoli",
        "Gujarat"
    ],
    [
        "Bareilly",
        "Uttar Pradesh"
    ],
    [
        "Baripada",
        "Odisha"
    ],
    [
        "Barmer",
        "Rajasthan"
    ],
    [
        "Barnagar",
        "Madhya Pradesh"
    ],
    [
        "Barrackpore",
        "West Bengal"
    ],
    [
        "Baruipur",
        "West Bengal"
    ],
    [
        "Basirhat",
        "West Bengal"
    ],
    [
        "Bassi",
        "Rajasthan"
    ],
    [
        "Belgaum",
        "Karnataka"
    ],
    [
        "Bellary",
        "Karnataka"
    ],
    [
        "Berhampore",
        "West Bengal"
    ],
    [
        "Berhampur",
        "Odisha"
    ],
    [
        "Betma",
        "Madhya Pradesh"
    ],
    [
        "Betul",
        "Madhya Pradesh"
    ],
    [
        "Bhadrak",
        "Odisha"
    ],
    [
        "Bhagalpur",
        "Bihar"
    ],
    [
        "Bhandara ",
        "Maharashtra"
    ],
    [
        "Bhanpura",
        "Madhya Pradesh"
    ],
    [
        "Bharatpur",
        "Rajasthan"
    ],
    [
        "Bharuch",
        "Gujarat"
    ],
    [
        "Bhatinda",
        "Punjab"
    ],
    [
        "Bhavnagar",
        "Gujarat"
    ],
    [
        "Bhilai",
        "Chhattisgarh"
    ],
    [
        "Bhilwara",
        "Rajasthan"
    ],
    [
        "Bhimavaram ",
        "Andhra Pradesh"
    ],
    [
        "Bhind",
        "Madhya Pradesh"
    ],
    [
        "Bhinmal",
        "Rajasthan"
    ],
    [
        "Bhiwadi",
        "Rajasthan"
    ],
    [
        "Bhopal",
        "Madhya Pradesh"
    ],
    [
        "Bhubaneshwar",
        "Odisha"
    ],
    [
        "Bhuj",
        "Gujarat"
    ],
    [
        "Biaora",
        "Madhya Pradesh"
    ],
    [
        "Bidar",
        "Karnataka"
    ],
    [
        "Bijapur",
        "Karnataka"
    ],
    [
        "Bijolia",
        "Rajasthan"
    ],
    [
        "Bikaner",
        "Rajasthan"
    ],
    [
        "Bilaspur",
        "Chhattisgarh"
    ],
    [
        "Bilimora",
        "Gujarat"
    ],
    [
        "Birur",
        "Karnataka"
    ],
    [
        "Boisar",
        "Maharashtra"
    ],
    [
        "Bolangir",
        "Odisha"
    ],
    [
        "Borsad",
        "Gujarat"
    ],
    [
        "Botad",
        "Gujarat"
    ],
    [
        "Bundi",
        "Rajasthan"
    ],
    [
        "Burdwan",
        "West Bengal"
    ],
    [
        "Burhanpur",
        "Madhya Pradesh"
    ],
    [
        "Chamba",
        "Himachal Pradesh"
    ],
    [
        "Chandigarh",
        "Chandigarh"
    ],
    [
        "Chandigarh",
        "Punjab"
    ],
    [
        "Chandikhol",
        "Odisha"
    ],
    [
        "Chandrapur",
        "Maharashtra"
    ],
    [
        "Channagiri",
        "Karnataka"
    ],
    [
        "Chattarpur",
        "Madhya Pradesh"
    ],
    [
        "Chennai",
        "Tamil Nadu"
    ],
    [
        "Chikhli",
        "Gujarat"
    ],
    [
        "Chikkabalapur",
        "Karnataka"
    ],
    [
        "Chikmagalur",
        "Karnataka"
    ],
    [
        "Chikodi",
        "Karnataka"
    ],
    [
        "Chindwara",
        "Madhya Pradesh"
    ],
    [
        "Chintamani",
        "Karnataka"
    ],
    [
        "Chitradurga",
        "Karnataka"
    ],
    [
        "Chittoor",
        "Andhra Pradesh"
    ],
    [
        "Chittorgarh",
        "Rajasthan"
    ],
    [
        "Chomu",
        "Rajasthan"
    ],
    [
        "Churu",
        "Rajasthan"
    ],
    [
        "Coimbatore",
        "Tamil Nadu"
    ],
    [
        "Coochbehar",
        "West Bengal"
    ],
    [
        "Cuddalore",
        "Tamil Nadu"
    ],
    [
        "Cuddapah",
        "Andhra Pradesh"
    ],
    [
        "Cuttack",
        "Odisha"
    ],
    [
        "Dabhoi",
        "Gujarat"
    ],
    [
        "Dahod",
        "Gujarat"
    ],
    [
        "Damoh",
        "Madhya Pradesh"
    ],
    [
        "Darbhanga",
        "Bihar"
    ],
    [
        "Datia",
        "Madhya Pradesh"
    ],
    [
        "Dausa",
        "Rajasthan"
    ],
    [
        "Davangere",
        "Karnataka"
    ],
    [
        "Deesa",
        "Gujarat"
    ],
    [
        "Dehgam",
        "Gujarat"
    ],
    [
        "Dehradun",
        "Uttarakhand"
    ],
    [
        "Dera Bassi",
        "Punjab"
    ],
    [
        "Devanahalli",
        "Karnataka"
    ],
    [
        "Dewas",
        "Madhya Pradesh"
    ],
    [
        "Dhamtari",
        "Chhattisgarh"
    ],
    [
        "Dhanbad",
        "Jharkhand"
    ],
    [
        "Dhar",
        "Madhya Pradesh"
    ],
    [
        "Dhar (Jaora)",
        "Madhya Pradesh"
    ],
    [
        "Dharamshala",
        "Himachal Pradesh"
    ],
    [
        "Dhenkanal",
        "Odisha"
    ],
    [
        "Dhoraji",
        "Gujarat"
    ],
    [
        "Dhule",
        "Maharashtra"
    ],
    [
        "Dibrugarh",
        "Assam"
    ],
    [
        "Dindigul",
        "Tamil Nadu"
    ],
    [
        "Dindori",
        "Madhya Pradesh"
    ],
    [
        "Dungarpur",
        "Rajasthan"
    ],
    [
        "Durgapur",
        "West Bengal"
    ],
    [
        "Dwarka",
        "Gujarat"
    ],
    [
        "Elluru",
        "Andhra Pradesh"
    ],
    [
        "Erode",
        "Tamil Nadu"
    ],
    [
        "Faizabad",
        "Uttar Pradesh"
    ],
    [
        "Faridabad",
        "Haryana"
    ],
    [
        "Fatehabad",
        "Haryana"
    ],
    [
        "Fatehpur",
        "Uttar Pradesh"
    ],
    [
        "Firozabad",
        "Uttar Pradesh"
    ],
    [
        "Gadag",
        "Karnataka"
    ],
    [
        "Gadchiorli",
        "Maharashtra"
    ],
    [
        "Gajapati",
        "Odisha"
    ],
    [
        "Gandhidham",
        "Gujarat"
    ],
    [
        "Gandhinagar",
        "Gujarat"
    ],
    [
        "Gangtok",
        "Sikkim"
    ],
    [
        "Ganjam",
        "Odisha"
    ],
    [
        "Goa",
        "Goa"
    ],
    [
        "Gobichettipalayam",
        "Tamil Nadu"
    ],
    [
        "Godhra",
        "Gujarat"
    ],
    [
        "Gokak",
        "Karnataka"
    ],
    [
        "Gondal",
        "Gujarat"
    ],
    [
        "Gondia ",
        "Maharashtra"
    ],
    [
        "Gorakhpur",
        "Uttar Pradesh"
    ],
    [
        "Gulbarga",
        "Karnataka"
    ],
    [
        "Gummidipoondi",
        "Tamil Nadu"
    ],
    [
        "Guna",
        "Madhya Pradesh"
    ],
    [
        "Guntur",
        "Andhra Pradesh"
    ],
    [
        "Gurgaon",
        "Haryana "
    ],
    [
        "Gurugram",
        "Haryana"
    ],
    [
        "Guwahati",
        "Assam"
    ],
    [
        "Gwalior",
        "Madhya Pradesh"
    ],
    [
        "Haldia",
        "West Bengal"
    ],
    [
        "Haldwani",
        "Uttarakhand"
    ],
    [
        "Halol",
        "Gujarat"
    ],
    [
        "Hamirpur",
        "Himachal Pradesh"
    ],
    [
        "Hanumangarh",
        "Rajasthan"
    ],
    [
        "Hapur",
        "Uttar Pradesh"
    ],
    [
        "Harda",
        "Madhya Pradesh"
    ],
    [
        "Hassan",
        "Karnataka"
    ],
    [
        "Hathras",
        "Uttar Pradesh"
    ],
    [
        "Haveri",
        "Karnataka"
    ],
    [
        "Hayathnagar",
        "Telangana"
    ],
    [
        "Hazaribagh",
        "Jharkhand"
    ],
    [
        "Himmatnagar",
        "Gujarat"
    ],
    [
        "Hiriyur",
        "Karnataka"
    ],
    [
        "Hisar",
        "Haryana"
    ],
    [
        "Hoshangabad",
        "Madhya Pradesh"
    ],
    [
        "Hoshiarpur",
        "Punjab"
    ],
    [
        "Hoskote",
        "Karnataka"
    ],
    [
        "Hospet",
        "Karnataka"
    ],
    [
        "Hosur",
        "Tamil Nadu"
    ],
    [
        "Hubli",
        "Karnataka"
    ],
    [
        "Hyderabad",
        "Hyderabad"
    ],
    [
        "Hyderabad",
        "Telangana"
    ],
    [
        "Idar",
        "Gujarat"
    ],
    [
        "Imphal",
        "Manipur"
    ],
    [
        "Indore",
        "Madhya Pradesh"
    ],
    [
        "Jabalpur",
        "Madhya Pradesh"
    ],
    [
        "Jagdalpur",
        "Chhattisgarh"
    ],
    [
        "Jagraon",
        "Punjab"
    ],
    [
        "Jaipur",
        "Rajasthan"
    ],
    [
        "Jajpur",
        "Odisha"
    ],
    [
        "Jalandhar",
        "Punjab"
    ],
    [
        "Jalgaon",
        "Maharashtra"
    ],
    [
        "Jalore",
        "Rajasthan"
    ],
    [
        "Jamkhandi",
        "Karnataka"
    ],
    [
        "Jammu",
        "Jammu & Kashmir"
    ],
    [
        "Jamnagar",
        "Gujarat"
    ],
    [
        "Jamshedpur",
        "Jharkhand"
    ],
    [
        "Janjgir Champa",
        "Chhattisgarh"
    ],
    [
        "Japanese",
        "Haryana"
    ],
    [
        "Jeypore",
        "Odisha"
    ],
    [
        "Jhajjar",
        "Haryana"
    ],
    [
        "Jhalawar",
        "Rajasthan"
    ],
    [
        "Jhalod",
        "Gujarat"
    ],
    [
        "Jhansi",
        "Uttar Pradesh"
    ],
    [
        "Jhunjhunu",
        "Rajasthan"
    ],
    [
        "Jodhpur",
        "Rajasthan"
    ],
    [
        "Jorhat",
        "Assam"
    ],
    [
        "Junagarh",
        "Gujarat"
    ],
    [
        "Kadi",
        "Gujarat"
    ],
    [
        "Kaithal",
        "Haryana"
    ],
    [
        "Kakinada",
        "Andhra Pradesh"
    ],
    [
        "Kala Amb",
        "Himachal Pradesh"
    ],
    [
        "Kalol",
        "Gujarat"
    ],
    [
        "Kalyan",
        "Maharashtra"
    ],
    [
        "Kamrej",
        "Gujarat"
    ],
    [
        "Kancheepuram",
        "Tamil Nadu"
    ],
    [
        "Kanpur",
        "Uttar Pradesh"
    ],
    [
        "Karaikudi",
        "Tamil Nadu"
    ],
    [
        "Karimnagar",
        "Telangana"
    ],
    [
        "Karnal",
        "Haryana"
    ],
    [
        "Karur",
        "Tamil Nadu"
    ],
    [
        "Kashipur ",
        "Uttarakhand"
    ],
    [
        "Kathua",
        "Jammu & Kashmir"
    ],
    [
        "Katni",
        "Madhya Pradesh"
    ],
    [
        "Kawardha",
        "Chhattisgarh"
    ],
    [
        "Kawas",
        "Gujarat"
    ],
    [
        "Kendrapara",
        "Odisha"
    ],
    [
        "Keonjhar",
        "Odisha"
    ],
    [
        "Khambhat",
        "Gujarat"
    ],
    [
        "Khamgaon",
        "Maharashtra"
    ],
    [
        "Khammam",
        "Telangana"
    ],
    [
        "Khandwa",
        "Madhya Pradesh"
    ],
    [
        "Kharagpur",
        "West Bengal"
    ],
    [
        "Kharar",
        "Punjab"
    ],
    [
        "Khargone",
        "Madhya Pradesh"
    ],
    [
        "Kheralu",
        "Gujarat"
    ],
    [
        "Khurda",
        "Odisha"
    ],
    [
        "Kim",
        "Gujarat"
    ],
    [
        "Kochi",
        "Kerala"
    ],
    [
        "Kodad",
        "Telangana"
    ],
    [
        "Kolar",
        "Karnataka"
    ],
    [
        "Kolhapur",
        "Maharashtra"
    ],
    [
        "Kolkata",
        "West Bengal"
    ],
    [
        "Kota",
        "Rajasthan"
    ],
    [
        "Kottayam",
        "Kerala"
    ],
    [
        "Kozhikode",
        "Kerala"
    ],
    [
        "Krishnanagar",
        "West Bengal"
    ],
    [
        "Kullu",
        "Himachal Pradesh"
    ],
    [
        "Kumbakonam",
        "Tamil Nadu"
    ],
    [
        "Kurnool",
        "Andhra Pradesh"
    ],
    [
        "Latur",
        "Maharashtra"
    ],
    [
        "Lucknow",
        "Uttar Pradesh"
    ],
    [
        "Ludhiana",
        "Punjab"
    ],
    [
        "Lunawada",
        "Gujarat"
    ],
    [
        "Madhugiri",
        "Karnataka"
    ],
    [
        "Madurai",
        "Tamil Nadu"
    ],
    [
        "Mahed",
        "Maharashtra"
    ],
    [
        "Mahoba",
        "Uttar Pradesh"
    ],
    [
        "Maihar",
        "Madhya Pradesh"
    ],
    [
        "Malda",
        "West Bengal"
    ],
    [
        "Malegaon",
        "Maharashtra"
    ],
    [
        "Malihabad",
        "Uttar Pradesh"
    ],
    [
        "Malkangiri",
        "Odisha"
    ],
    [
        "Malur",
        "Karnataka"
    ],
    [
        "Mancherial",
        "Telangana"
    ],
    [
        "Mandi",
        "Himachal Pradesh"
    ],
    [
        "Mandla",
        "Madhya Pradesh"
    ],
    [
        "Mandsaur",
        "Madhya Pradesh"
    ],
    [
        "Mandya",
        "Karnataka"
    ],
    [
        "Mangalore",
        "Karnataka"
    ],
    [
        "Margao",
        "Goa"
    ],
    [
        "Mass",
        "Haryana"
    ],
    [
        "Mathura",
        "Uttar Pradesh"
    ],
    [
        "Meerut",
        "Uttar Pradesh"
    ],
    [
        "Mehsana",
        "Gujarat"
    ],
    [
        "Modasa",
        "Gujarat"
    ],
    [
        "Moga",
        "Punjab"
    ],
    [
        "Morbi",
        "Gujarat"
    ],
    [
        "Mumbai",
        "Maharashtra"
    ],
    [
        "Mundra",
        "Gujarat"
    ],
    [
        "Mungeli",
        "Chhattisgarh"
    ],
    [
        "Murbad",
        "Maharashtra"
    ],
    [
        "Muzaffarpur",
        "Bihar"
    ],
    [
        "Muzzafarnagar",
        "Uttar Pradesh"
    ],
    [
        "Mysore",
        "Karnataka"
    ],
    [
        "Nabha",
        "Punjab"
    ],
    [
        "Nadiad",
        "Gujarat"
    ],
    [
        "Nagaon",
        "Assam"
    ],
    [
        "Nagda",
        "Madhya Pradesh"
    ],
    [
        "Nagercoil",
        "Tamil Nadu"
    ],
    [
        "Nagpur",
        "Maharashtra"
    ],
    [
        "Naharlagun",
        "Arunachal Pradesh"
    ],
    [
        "Nalagarh",
        "Himachal Pradesh"
    ],
    [
        "Nalgonda",
        "Telangana"
    ],
    [
        "Namakkal",
        "Tamil Nadu"
    ],
    [
        "Nan Pondha",
        "Gujarat"
    ],
    [
        "Nanded",
        "Maharashtra"
    ],
    [
        "Narasaraopet",
        "Andhra Pradesh"
    ],
    [
        "Narsampet",
        "Telangana"
    ],
    [
        "Narsinghgarh",
        "Madhya Pradesh"
    ],
    [
        "Narsinghpur",
        "Madhya Pradesh"
    ],
    [
        "Nasik",
        "Maharashtra"
    ],
    [
        "Nasrullaganj",
        "Madhya Pradesh"
    ],
    [
        "Navsari",
        "Gujarat"
    ],
    [
        "Nayagarh",
        "Odisha"
    ],
    [
        "Neemuch",
        "Madhya Pradesh"
    ],
    [
        "Nelamangala",
        "Karnataka"
    ],
    [
        "Nellore",
        "Andhra Pradesh"
    ],
    [
        "New Delhi",
        "New Delhi"
    ],
    [
        "Nizamabad",
        "Telangana"
    ],
    [
        "Noida",
        "Uttar Pradesh"
    ],
    [
        "Ongole",
        "Andhra Pradesh"
    ],
    [
        "Palanpur",
        "Gujarat"
    ],
    [
        "Pali",
        "Rajasthan"
    ],
    [
        "Panna",
        "Madhya Pradesh"
    ],
    [
        "Panvel",
        "Maharashtra"
    ],
    [
        "Paonta Sahib",
        "Himachal Pradesh"
    ],
    [
        "Paradeep",
        "Odisha"
    ],
    [
        "Patan",
        "Gujarat"
    ],
    [
        "Pataudi",
        "Haryana"
    ],
    [
        "Patia  ",
        "Odisha"
    ],
    [
        "Patiala",
        "Punjab"
    ],
    [
        "Patna",
        "Bihar"
    ],
    [
        "Peddapally",
        "Telangana"
    ],
    [
        "Pehowa",
        "Haryana"
    ],
    [
        "Perambalur",
        "Tamil Nadu"
    ],
    [
        "Perintalmanna",
        "Kerala"
    ],
    [
        "Phulbani",
        "Odisha"
    ],
    [
        "Pithampur",
        "Madhya Pradesh"
    ],
    [
        "Pithoragarh",
        "Uttarakhand"
    ],
    [
        "Pollachi",
        "Tamil Nadu"
    ],
    [
        "Pondicherry",
        "Pondicherry"
    ],
    [
        "Porbandar",
        "Gujarat"
    ],
    [
        "Porur",
        "Tamil Nadu"
    ],
    [
        "Produttur",
        "Andhra Pradesh"
    ],
    [
        "Pune",
        "Maharashtra"
    ],
    [
        "Puri",
        "Odisha"
    ],
    [
        "Purnia",
        "Bihar"
    ],
    [
        "Puttur",
        "Andhra Pradesh"
    ],
    [
        "Puttur",
        "Karnataka"
    ],
    [
        "Raebareli",
        "Uttar Pradesh"
    ],
    [
        "Raichur",
        "Karnataka"
    ],
    [
        "Raiganj",
        "West Bengal"
    ],
    [
        "Raigarh",
        "Chhattisgarh"
    ],
    [
        "Raipur",
        "Chhattisgarh"
    ],
    [
        "Rairangpur",
        "Odisha"
    ],
    [
        "Raisen",
        "Madhya Pradesh"
    ],
    [
        "Rajahmundry",
        "Andhra Pradesh"
    ],
    [
        "Rajkot",
        "Gujarat"
    ],
    [
        "Rajnandgaon",
        "Chhattisgarh"
    ],
    [
        "Rajpura",
        "Punjab"
    ],
    [
        "Rajsamand",
        "Rajasthan"
    ],
    [
        "Ramanagara ",
        "Karnataka"
    ],
    [
        "Ranchi",
        "Jharkhand"
    ],
    [
        "Ratlam",
        "Madhya Pradesh"
    ],
    [
        "Ratnagiri",
        "Maharashtra"
    ],
    [
        "Rau",
        "Madhya Pradesh"
    ],
    [
        "Rayadga",
        "Odisha"
    ],
    [
        "Rewa",
        "Madhya Pradesh"
    ],
    [
        "Rewari",
        "Haryana"
    ],
    [
        "Robertsganj",
        "Uttar Pradesh"
    ],
    [
        "Rohtak",
        "Haryana"
    ],
    [
        "Roorkee",
        "Uttarakhand"
    ],
    [
        "Ropar",
        "Punjab"
    ],
    [
        "Rourkela",
        "Odisha"
    ],
    [
        "Sagar",
        "Karnataka"
    ],
    [
        "Sagar",
        "Madhya Pradesh"
    ],
    [
        "Salem",
        "Tamil Nadu"
    ],
    [
        "Sambalpur",
        "Odisha"
    ],
    [
        "Sanand",
        "Gujarat"
    ],
    [
        "Sanathnagar",
        "Telangana"
    ],
    [
        "Sanawad",
        "Madhya Pradesh"
    ],
    [
        "Sangareddy",
        "Telangana"
    ],
    [
        "Sangli",
        "Maharashtra"
    ],
    [
        "Sangrur",
        "Punjab"
    ],
    [
        "Satara",
        "Maharashtra"
    ],
    [
        "Satna",
        "Madhya Pradesh"
    ],
    [
        "Secundrabad",
        "Telangana"
    ],
    [
        "Sehore",
        "Madhya Pradesh"
    ],
    [
        "Seoni",
        "Madhya Pradesh"
    ],
    [
        "Shahdol",
        "Madhya Pradesh"
    ],
    [
        "Shahjahanpur ",
        "Uttar Pradesh"
    ],
    [
        "Shajapur",
        "Madhya Pradesh"
    ],
    [
        "Sheopur",
        "Madhya Pradesh"
    ],
    [
        "Shillong",
        "Meghalaya"
    ],
    [
        "Shimla",
        "Himachal Pradesh"
    ],
    [
        "Shimoga",
        "Karnataka"
    ],
    [
        "Shirpur-Dhule",
        "Maharashtra"
    ],
    [
        "Shivpuri",
        "Madhya Pradesh"
    ],
    [
        "Sholapur",
        "Maharashtra"
    ],
    [
        "Shujalpur",
        "Madhya Pradesh"
    ],
    [
        "Siddhpur",
        "Gujarat"
    ],
    [
        "Siddipet",
        "Telangana"
    ],
    [
        "Sidhi",
        "Madhya Pradesh"
    ],
    [
        "Sikar",
        "Rajasthan"
    ],
    [
        "Siliguri",
        "West Bengal"
    ],
    [
        "Silvassa",
        "Dadra &  Nagar Haveli "
    ],
    [
        "Singrauli",
        "Madhya Pradesh"
    ],
    [
        "Sirhind",
        "Punjab"
    ],
    [
        "Sirsi",
        "Karnataka"
    ],
    [
        "Sitamau",
        "Madhya Pradesh"
    ],
    [
        "Solan",
        "Himachal Pradesh"
    ],
    [
        "Sonipat",
        "Haryana"
    ],
    [
        "Sopore",
        "Jammu & Kashmir"
    ],
    [
        "Sri Ganganagar",
        "Rajasthan"
    ],
    [
        "Srikakulam",
        "Andhra Pradesh"
    ],
    [
        "Srinagar",
        "Jammu & Kashmir"
    ],
    [
        "Sundarnagar",
        "Himachal Pradesh"
    ],
    [
        "Sundergarh",
        "Odisha"
    ],
    [
        "Surat",
        "Gujarat"
    ],
    [
        "Tambaram",
        "Tamil Nadu"
    ],
    [
        "Tarakeswar",
        "West Bengal"
    ],
    [
        "Tarn Taran EBK",
        "Punjab"
    ],
    [
        "Theni",
        "Tamil Nadu"
    ],
    [
        "Thrissur",
        "Kerala"
    ],
    [
        "Tikamgarh",
        "Madhya Pradesh"
    ],
    [
        "Tirunelveli",
        "Tamil Nadu"
    ],
    [
        "Tirupati",
        "Andhra Pradesh"
    ],
    [
        "Tirupur",
        "Tamil Nadu"
    ],
    [
        "Tohana",
        "Haryana"
    ],
    [
        "Tonk",
        "Rajasthan"
    ],
    [
        "Trichy",
        "Tamil Nadu"
    ],
    [
        "Tripura West",
        "Tripura"
    ],
    [
        "Trivandrum",
        "Kerala"
    ],
    [
        "Tumkur",
        "Karnataka"
    ],
    [
        "Tuticorin",
        "Tamil Nadu"
    ],
    [
        "Udaipur",
        "Rajasthan"
    ],
    [
        "Udhampur",
        "Jammu & Kashmir"
    ],
    [
        "Udupi",
        "Karnataka"
    ],
    [
        "Ujjain",
        "Madhya Pradesh"
    ],
    [
        "Umarkote",
        "Odisha"
    ],
    [
        "Umergaon",
        "Gujarat"
    ],
    [
        "Umreth",
        "Gujarat"
    ],
    [
        "Una",
        "Gujarat"
    ],
    [
        "Una",
        "Himachal Pradesh"
    ],
    [
        "Vadodara",
        "Gujarat"
    ],
    [
        "Valsad",
        "Gujarat"
    ],
    [
        "Vapi",
        "Gujarat"
    ],
    [
        "Varanasi",
        "Uttar Pradesh"
    ],
    [
        "Vasai",
        "Maharashtra"
    ],
    [
        "Vasco Da Gama",
        "Goa "
    ],
    [
        "Vellore",
        "Tamil Nadu"
    ],
    [
        "Veraval",
        "Gujarat"
    ],
    [
        "Vidisha",
        "Madhya Pradesh"
    ],
    [
        "Vijapur",
        "Gujarat"
    ],
    [
        "Vijayawada",
        "Andhra Pradesh"
    ],
    [
        "Visakapatanam",
        "Andhra Pradesh"
    ],
    [
        "Vizianagaram",
        "Andhra Pradesh"
    ],
    [
        "Vsanda",
        "Gujarat"
    ],
    [
        "Vyara",
        "Gujarat"
    ],
    [
        "Waragal",
        "Telangana"
    ],
    [
        "Warangal",
        "Telangana"
    ],
    [
        "Wardha",
        "Maharashtra"
    ],
    [
        "Yalhanka",
        "Karnataka"
    ],
    [
        "Yamunanagar",
        "Haryana"
    ],
    [
        "Yavatmal",
        "Maharashtra"
    ]
];

  
  list7: any = ["Yes", "No"];


  constructor(
    private formBuilder: FormBuilder,
    private spinner: SpinnerService,
    private joineeService: JoineeService,
    private motorService: MotorService,
    public datepipe: DatePipe,
    private alert: AlertService
  ) {
    this.bsDatepickerConfig.dateInputFormat = "DD/MM/YYYY";
    this.bsDatepickerConfig.containerClass = "theme-green";
    this.bsDatepickerConfig.showWeekNumbers = false;
    const startDate = new Date(new Date().setHours(0, 0, 0, 0));

    // const today = new Date();
    
    // this.adultMinDOB = new Date(startDate.getTime());
    // // this.adultMinDOB.setFullYear(startDate.getFullYear() - Constants.PROPOSER_MINIMUM_AGE_LIMIT);
    // this.adultMinDOB.setFullYear(startDate.getFullYear() - 0);
    // this.adultMaxDOB = new Date(startDate.getTime());
    // // this.adultMaxDOB.setFullYear(startDate.getFullYear() - Constants.PROPOSER_MAXIMUM_AGE_LIMIT);
    // this.adultMaxDOB.setFullYear(startDate.getFullYear() - 150);
  }

  get f() {
    return this.serverTaskForm.controls;
  }

  ngOnInit(): void {
    this.serverTaskForm = this.formBuilder.group({
      salutation:["",[Validators.required]],
      name: ["", [Validators.required]],
      dateOfBirth: ["",[Validators.required]],
    //   age: ["", [Validators.required]],
      mobileNumber: ["", [Validators.required]],
      presentLocation: ["", []],
      locationAppliedFor: ["", [Validators.required]],
      stateAppliedFor: [{ value: "", disabled: true }, [Validators.required]],
      presentFunction: ["", []],
      functionAppliedFor: ["", [Validators.required]],
      currentCtc: ["", [Validators.required]],
      noticePeriod: ["", [Validators.required]],
      highestQualification: ["", [Validators.required]],
      workWithIFFCOTokio: ["", [Validators.required]],
      presentOrganizationName: ["", []],
      insuranceQualification: ["", [Validators.required]],
      experienceInInsuranceIndustry: ["", []],
      emailId: [
        "",
        Validators.compose([
          Validators.required,
          Validators.pattern(Constants.EMAIL_REGEX),
        ]),
      ],
      document: ["", [Validators.required]],
      workExperienceInBFSI: ["", [Validators.required]],
    });

    this.f.workWithIFFCOTokio.setValue(false);
    this.f.workExperienceInBFSI.setValue(false);
    this.f.experienceInInsuranceIndustry.disable();

    // this.locationMaster = this.joineeService.getLocationMaster();
    // this.ctcMaster = this.joineeService.getCTCMaster();
    // this.highestEductationMaster = this.joineeService.getHighestEducationMaster();
    // this.noticePeriodMaster = this.joineeService.getNoticePeriodMaster();
    // this.ageMaster = this.joineeService.getAgeMaster();
    // this.insuranceQualificationMaster = this.joineeService.getInsuranceQualificationMaster();
    // this.functionMaster = this.joineeService.getFunctionMaster();
    // this.experienceMaster = this.joineeService.getExperienceMaster();
 
    this.locationMaster = this.locationMaster.map((item) => ({
      city: item[0],
      state: item[1],
    }));

    const today = new Date();
    
    // Calculate the date 45 years ago (oldest allowed DOB)
    this.adultMaxDOB = new Date(today.setFullYear(today.getFullYear() - 45));
    
    // Reset today's date for min date calculation
    const minDate = new Date();
    
    // Calculate the date 18 years ago (youngest allowed DOB)
    this.adultMinDOB = new Date(minDate.setFullYear(minDate.getFullYear() - 18));
  }

  workExperienceBFSI() {
    if (this.serverTaskForm.controls.workExperienceInBFSI.value) {
      this.f.experienceInInsuranceIndustry.disable();
      this.serverTaskForm.controls.experienceInInsuranceIndustry.setValue("");
    } else {
      this.f.experienceInInsuranceIndustry.enable();
    }
  }

  async onSubmit() {
    this.errors = [];
    this.submitted = true;

    // console.log(this.serverTaskForm);

    // console.log(this.datepipe.transform(this.serverTaskForm.controls.dateOfBirth.value, 'yyyy-MM-dd'))

    const documentData = await this.toBase64(
      this.serverTaskForm.controls.document.value[0]
    );
    // console.log(this.serverTaskForm);

    // debugger;
    if (
      this.serverTaskForm.controls.document.value[0].type != "application/pdf"
    ) {
      this.pdfOnly = true;
      this.serverTaskForm.controls.document.reset();
      return;
    } else {
      this.pdfOnly = false;
    }

    // console.log(documentData);
    if (this.serverTaskForm.invalid) {
      this.spinner.hideSpinner();
      return;
    }

    const payload = {
      name: this.serverTaskForm.controls.name.value,
      salutation: this.serverTaskForm.controls.salutation.value,
      dateOfBirth: this.datepipe.transform(this.serverTaskForm.controls.dateOfBirth.value, 'yyyy-MM-dd'),
    //   age: this.serverTaskForm.controls.age.value,
      mobileNumber: this.serverTaskForm.controls.mobileNumber.value,
      presentLocation: this.serverTaskForm.controls.presentLocation.value,
      presentFunction: this.serverTaskForm.controls.presentFunction.value,
      currentCtc: this.serverTaskForm.controls.currentCtc.value,
      highestQualification:
        this.serverTaskForm.controls.highestQualification.value,
      insuranceQualification:
        this.serverTaskForm.controls.insuranceQualification.value,
      emailId: this.serverTaskForm.controls.emailId.value,
      experienceInInsuranceIndustry:
        this.serverTaskForm.controls.experienceInInsuranceIndustry.value,
      attachedCvName: this.serverTaskForm.controls.document.value[0].name,
      document: await this.toBase64(
        this.serverTaskForm.controls.document.value[0]
      ),
      locationAppliedFor: this.serverTaskForm.controls.locationAppliedFor.value,
      stateAppliedFor: this.serverTaskForm.controls.stateAppliedFor.value,
      functionAppliedFor: this.serverTaskForm.controls.functionAppliedFor.value,
      presentOrganizationName:
        this.serverTaskForm.controls.presentOrganizationName.value,
      noticePeriodInpresentOrganization:
        this.serverTaskForm.controls.noticePeriod.value,
      previouslyWorkWithIFFCO:
        this.serverTaskForm.controls.workWithIFFCOTokio.value,
      experienceInBFSI: this.serverTaskForm.controls.workExperienceInBFSI.value,
    };

    console.log(payload);

    // payload.document = documentData;
    // console.log(payload);
    const responses = await this.joineeService.saveNewJoineeDetails(payload);
    const response = responses[0];
    // console.log(response);
    if (response == "Email ID Already Present") {
      this.alert.info(
        "The Email Id provided already exist, Please choose a different Email Id"
      );
      this.spinner.hideSpinner();
      return;
    } else if (response == "Mobile Number Already Present") {
      this.alert.info(
        "The Mobile Number provided already exist, Please choose a different Mobile Number"
      );
      this.spinner.hideSpinner();
      return;
    } else if (response) {
      this.serverTaskForm.reset();
      this.alert.info(
        "Thank you for showing interest in IFFCO Tokio. Our team will get back to you shortly"
      );
      this.spinner.hideSpinner();
      return;
    } else {
      this.alert.info("Something went Wrong, Please try again after sometime");
      this.spinner.hideSpinner();
    }
  }

  async toBase64(file: File) {
    const arrayBuffer = (await readFileAsync(file)) as ArrayBuffer;
    let binary = "";
    const bytes = new Uint8Array(arrayBuffer);
    const len = bytes.byteLength;
    for (let i = 0; i < len; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    return window.btoa(binary);
    function readFileAsync(file: File) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsArrayBuffer(file);
      });
    }
  }

  onCityChange(selectedCity: any) {
    
    if (selectedCity.state) {
      this.f.stateAppliedFor.setValue(selectedCity.state);
    } else {
      this.f.stateAppliedFor.reset();
    }
  }
}
